<template>
    <div class="d-flex flex-row flex-nowrap justify-content-between align-items-center">
        <slot/>
    </div>
</template>
